import { makeEnvironmentProviders } from '@angular/core';
import { provideIcons } from '@virginmediao2/momentum-angular';
import { VmHub3, VmBoxVirginMedia, VmTvRemote } from '@virginmediao2/momentum-icons/icons/vm';
import { FabAndroid, FabApple, FabGoogle, FabMicrosoft } from '@virginmediao2/momentum-icons/icons/fab';
import {
  FarArrowRightArrowLeft,
  FarBolt,
  FarBoxOpenFull,
  FarBriefcase,
  FarChevronLeft,
  FarComments,
  FarEye,
  FarHandshakeSimple,
  FarHouse,
  FarMobile,
  FarPenNib,
  FarPhone,
  FarTv,
  FarUser,
  FarClock,
  FarLock,
  FarUserHelmetSafety,
  FarCircleInfo,
  FarCalendarDays,
  FarFaceFrown,
  FarBell,
  FarChevronRight,
  FarCalendarDay,
  FarGaugeHigh,
  FarHouseSignal,
  FarTablet,
  FarHouseLock,
  FarHousePersonReturn,
  FarShieldCheck,
  FarUserShield,
  FarShareNodes,
  FarBuilding,
  FarCircleExclamation,
  FarImageLandscape,
  FarVolumeSlash,
  FarGrip,
  FarPhoneVolume,
  FarSterlingSign,
  FarArrowsRepeat,
  FarScrewdriverWrench,
  FarMobileButton,
  FarHouseChimney,
  FarMagnifyingGlass,
  FarEnvelopeOpenText,
  FarHardDrive,
  FarBox,
} from '@virginmediao2/momentum-icons/icons/far';
import {
  FasChevronRight,
  FasCircleExclamation,
  FasCircleCheck,
  FasCircleInfo,
  FasListCheck,
  FasChevronLeft,
  FasCircleXmark,
  FasSlidersUp,
} from '@virginmediao2/momentum-icons/icons/fas';
import {
  FalVolumeSlash,
  FalArrowsRotate,
  FalCalendarDays,
  FalFaceFrown,
  FalCircleLocationArrow,
  FalSignal,
  FalWifi,
  FalChevronLeft,
  FalChevronRight,
  FalFileCheck,
  FalLocationDot,
  FalPhone,
  FalArrowRotateRight,
  FalCompass,
  FalWifiSlash,
  FalMobile,
  FalPlug,
  FalLaptopMobile,
  FalKey,
  FalShareNodes,
  FalHousePersonReturn,
  FalRocketLaunch,
  FalPaperPlane,
  FalHouse,
  FalEnvelopeOpenText,
  FalRotateRight,
  FalChartLineUp,
  FalGaugeMin,
  FalBrowser,
  FalBan,
  FalListCheck,
  FalUnlockKeyhole,
  FalTriangleExclamation,
  FalTruckRampBox,
  FalMap,
  FalBoxOpenFull,
  FalMagnifyingGlassLocation,
  FalCircleQuestion,
  FalCircleExclamation,
  FalLightbulbOn,
  FalVolume,
  FalImageLandscape,
  FalGrip,
  FalNetworkWired,
  FalRectangleBarcode,
  FalCircleNodes,
  FalChartPieSimple,
  FalMapLocationDot,
  FalTag,
  FalMusic,
  FalCameraSecurity,
  FalLaptop,
  FalCarCircleBolt,
  FalMasksTheater,
  FalHeartPulse,
  FalGamepadModern,
  FalGem,
  FalHouseSignal,
  FalMobileNotch,
  FalPrint,
  FalTabletButton,
  FalMicrochip,
  FalSquareQuestion,
  FalIcons,
} from '@virginmediao2/momentum-icons/icons/fal';

export const provideAppIcons = () =>
  makeEnvironmentProviders([
    provideIcons({
      VmHub3,
      VmBoxVirginMedia,
      FarUser,
      FarLock,
      FasChevronRight,
      FarChevronLeft,
      FarBolt,
      FarHouse,
      FarBoxOpenFull,
      FarTv,
      FarPhone,
      FarMobile,
      FarEye,
      FarArrowRightArrowLeft,
      FarBriefcase,
      FarHandshakeSimple,
      FarComments,
      FarPenNib,
      FasCircleExclamation,
      FasCircleCheck,
      FarClock,
      FarUserHelmetSafety,
      FarCircleInfo,
      FarCalendarDays,
      FarFaceFrown,
      FabApple,
      FabGoogle,
      FabMicrosoft,
      FarBell,
      FalFaceFrown,
      FalCircleLocationArrow,
      FalSignal,
      FalWifi,
      FalChevronRight,
      FalChevronLeft,
      FarChevronRight,
      FalCalendarDays,
      FalFileCheck,
      FalLocationDot,
      FalPhone,
      FarCalendarDay,
      FarGaugeHigh,
      FarHouseSignal,
      FarTablet,
      FarHouseLock,
      FarHousePersonReturn,
      FarShieldCheck,
      FarUserShield,
      FarShareNodes,
      FarBuilding,
      FarCircleExclamation,
      FarImageLandscape,
      FarVolumeSlash,
      FarGrip,
      FarPhoneVolume,
      FarSterlingSign,
      FarArrowsRepeat,
      FarScrewdriverWrench,
      FarMobileButton,
      FarHouseChimney,
      FarMagnifyingGlass,
      FabAndroid,
      FalArrowRotateRight,
      FalCompass,
      FalWifiSlash,
      FalMobile,
      FalPlug,
      FalLaptopMobile,
      FalKey,
      FalShareNodes,
      FalHousePersonReturn,
      FalRocketLaunch,
      FalPaperPlane,
      FasCircleInfo,
      FalHouse,
      FalEnvelopeOpenText,
      FarEnvelopeOpenText,
      FalRotateRight,
      FalChartLineUp,
      FalGaugeMin,
      FalBrowser,
      FalBan,
      FalListCheck,
      FalUnlockKeyhole,
      FalTriangleExclamation,
      FarHardDrive,
      FasListCheck,
      FarBox,
      FalTruckRampBox,
      FalMap,
      FalBoxOpenFull,
      FalMagnifyingGlassLocation,
      FalCircleQuestion,
      FalCircleExclamation,
      VmTvRemote,
      FalLightbulbOn,
      FalVolume,
      FalImageLandscape,
      FalGrip,
      FalArrowsRotate,
      FalVolumeSlash,
      FasChevronLeft,
      FalNetworkWired,
      FalRectangleBarcode,
      FalCircleNodes,
      FalChartPieSimple,
      FalMapLocationDot,
      FalTag,
      FalMusic,
      FalCameraSecurity,
      FalLaptop,
      FalCarCircleBolt,
      FalMasksTheater,
      FalHeartPulse,
      FalGamepadModern,
      FalGem,
      FalHouseSignal,
      FalMobileNotch,
      FalPrint,
      FalTabletButton,
      FalMicrochip,
      FalSquareQuestion,
      FasCircleXmark,
      FasSlidersUp,
      FalIcons,
    }),
  ]);
